

import { RouteType } from "constants/RouteType";
import { FinancialProtectionMessageModel } from "model/screensModels/FinancialProtectionMessageModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { AuthService } from "services/auth/AuthService";

export class FinancialProtectionMessageService {

  //To get Financial Message list
  static getFinancialMessageList = async (requestBody: PaginatorModel| string) => {
    const url = RouteType.ADMIN + RouteType.FINANCIAL_PROTECTION_GUIDELINE_MESSAGE;
    const response = AuthService.postCryptoRequest(url, requestBody==='' ? '' : JSON.stringify(requestBody));
    return response;
  };

   //save Financial Message
   static addFinancialProtectionMessage = async (requestBody: FinancialProtectionMessageModel) => {
    const url = RouteType.ADMIN + RouteType.FINANCIAL_PROTECTION_GUIDELINE_MESSAGE + RouteType.STORE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  //delete Financial Message
  static deleteFinancialMessage = async (requestBody: FinancialProtectionMessageModel) => {
    const url = RouteType.ADMIN + RouteType.FINANCIAL_PROTECTION_GUIDELINE_MESSAGE + RouteType.DELETE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };
}